import { skipToken, useSuspenseQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { useMemo } from "react";

const FACILITY_MONTHLY_GENERATION = gql(`
  query FacilityMonthlyGeneration($facilityId: ID!, $year: Int!) {
    facility(id: $facilityId) {
      id
      monthlyGeneration(year: $year) {
        month
        hazardousKg
        acuteKg
        fillEventCount
        incompleteFillCount
        status
      }
    }
  }
`);

/**
 * Generation-driven monthly generation (kg) + status for a facility-year, for
 * the Generator Status card's generation column. Skips entirely unless
 * `enabled` (the ContainerTracking flag) is on, so it stays dark for tenants
 * that don't consume generation.
 */
export const useMonthlyGeneration = (
  facilityId: string | undefined,
  year: number | null,
  enabled: boolean
) => {
  const options = useMemo(() => {
    if (!enabled || !facilityId || year === null) {
      return skipToken;
    }
    return { variables: { facilityId, year } };
  }, [enabled, facilityId, year]);
  return useSuspenseQuery(FACILITY_MONTHLY_GENERATION, options);
};
